import React, { useEffect, useState } from "react";

import "./goondemand.css";


import AllImg from "./images/all.png";
import CommunityImg from "./images/community.png";
import GroupImg from "./images/group.png";
import onDemandImg from "./images/on-demand.png";
import PracticeImg from "./images/practice.png";
import Speaker from "./images/speaker.png";
import { getOndemandCategories, getOndemandClientCategories } from "../../../services/admin";
import GoOnDemandPractice1 from "./goOnDemandPractice1";
import { useSearchParams } from "react-router-dom";
import UpcomingPastEventPopup from "./upcomingPastEventPopup";
import { useDispatch, useSelector } from "react-redux";

export default function GoOnDemandClientPractice() {
  const [searchParams] = useSearchParams();
  const comingFrom = searchParams.get("to");
  const [sessions, setSessions] = useState([]);
  const [showTabs, setShowTabs] = useState(true);
  const [session_id, setsession_id] = useState('');
  const [eventType, seteventType] = useState('Upcoming');
  const { role } = useSelector((state) => state.auth);
  useEffect(() => {
    if (comingFrom == "ondemand" || comingFrom == "groupcoaching" || comingFrom == "practicecircles" || comingFrom == "speakerEvents" || comingFrom == "coachedgroupcoaching" || comingFrom == "communitysupportgroups" || comingFrom =="allpracticecircles"|| comingFrom == "speakerEventsPast") {
      setShowTabs(false);

    }
    
    getOndemandClientCategories().then((data) => {
      // if (data.data.status) {
      console.log(data.data.data);
      let array = data.data.data
      setSessions(array)
      console.log(array, "array");
      setsession_id(101);
        setShowTabs(false);
      // }
    })


  }, [])

  const setNewSessionId = (id) => {
    
        setsession_id(101);
        setShowTabs(false);
  
  }
const onYesClick = () =>{
  setShowTabs(false);
  seteventType("Upcoming")
}
const onNoClick = () =>{
  setShowTabs(false);
  seteventType("Past")
}

  return (
    <>
      {showTabs ?

        <div className="container-fluid ">
          <div className="container-fluid ">
            <div className="dashboard ">
              <div className="row">
                <div className="col-md-12">
                  <div className="quck-box">
                    <h2>Select Session Type</h2>
                    <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                      {sessions.slice(0, 3).map((item) => <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={item.id == 91 ? onDemandImg : item.id == 0 ? PracticeImg : GroupImg} alt="count" />
                          </div>
                          <span>
                            {item.sub_session_name}

                          </span>
                        </div>
                      </div>)}
                    </div>
                    <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                      {sessions.slice(3, 8).map((item) => <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={item.id == 96 ? CommunityImg : item.id == 95 ? Speaker : AllImg} alt="count" />
                          </div>
                          <span>

                            {item.sub_session_name}
                          </span>
                        </div>
                      </div>)}
                      
                       {/* {sessions.length > 0 && <div
                        onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={PracticeImg} alt="count" />
                          </div>
                          <span>

                            {'Demonstrations - Practice'}
                          </span>
                        </div>
                      </div>} */}
                    </div>
                      <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                      {sessions.length > 0 && role !="client" && <div
                        onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={AllImg} alt="count" />
                          </div>
                          <span>

                            {'All of the above'}
                          </span>
                        </div>
                      </div>}
                      <div
                        // onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointe go-ondemand-practice-none"
                      >
                        <div className="content-left">
                          {/* <div className="icon-left">
                            <img src={AllImg} alt="count" />
                          </div> */}
                          {/* <span>

                            {'All of the above'}
                          </span> */}
                        </div>
                      </div>
                       <div
                        // onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointer go-ondemand-practice-none"
                      >
                        <div className="content-left">
                          {/* <div className="icon-left">
                            <img src={AllImg} alt="count" />
                          </div> */}
                          {/* <span>

                            {'All of the above'}
                          </span> */}
                        </div>
                      </div>
                     
                    </div>
                     {/* <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes"> */}
                      {/* {sessions.length > 0 && <div
                        onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={AllImg} alt="count" />
                          </div>
                          <span>

                            {'All of the above'}
                          </span>
                        </div>
                      </div>} */}
                      {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        :
        <GoOnDemandPractice1 setSessions={setSessions} sessions={sessions} session_id={session_id} setsession_id={setsession_id} seteventType={seteventType} eventType={eventType} role={role} />
      }
      <UpcomingPastEventPopup 
      onYesClick={onYesClick}
      onNoClick={onNoClick}
      />
    </>
  );
}
